import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { ApprovalMatrixFilterRequest } from "@/main/models/request";
import { ApprovalMatrixSearchResponse } from "@/main/models/response";
import FiltersApprovalMatrix from "@/main/screens/registration/approvalMatrix/filtersApprovalMatrix/filtersApprovalMatrix";
import { IApprovalMatrixFilterFormOutput } from "@/main/screens/registration/approvalMatrix/filtersApprovalMatrix/utilsFilterApprovalMatrix";
import GridApprovalMatrix from "@/main/screens/registration/approvalMatrix/gridApprovalMatrix/gridApprovalMatrix";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { getTranslateByKey } from "@/main/services/utils";
import { useState } from "react";
import * as S from "./styles";

function SearchApprovalMatrix() {
	const [filtersRequest, setFiltersRequest] = useState<ApprovalMatrixFilterRequest | null>(null);
	const [dataGrid, setDataGrid] = useState<ApprovalMatrixSearchResponse[]>([]);

	function handleSubmit(data: IApprovalMatrixFilterFormOutput) {
		const request: ApprovalMatrixFilterRequest = {
			countryGuid: String(data.country.key),

			approvalMatrixName: data.matrixName || undefined,

			insurerGuid: data.insurer?.key ? String(data.insurer.key) : undefined,

			idApprovalMatrixType: data.approvalMatrixType?.key ? Number(data.approvalMatrixType.key) : undefined,

			idStatusRegister: data.statusRegister?.key ? Number(data.statusRegister.key) : undefined,

			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		handleClear();
		setFiltersRequest(request);
	}
	function handleClear() {
		setFiltersRequest(null);
		setDataGrid([]);
	}

	return (
		<ContainerScreen
			hasBackground
			title={`
      ${getTranslateByKey("information.registration")}
      ${" > "}
      ${getTranslateByKey("screen.approvalMatrix")}`}
		>
			<S.Container>
				<FiltersApprovalMatrix onClear={handleClear} onSubmit={handleSubmit} />
				<GridApprovalMatrix dataGrid={dataGrid} setDataGrid={setDataGrid} filter={filtersRequest} />
			</S.Container>
		</ContainerScreen>
	);
}

export default withQueryparams(SearchApprovalMatrix);
